import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { ICambioContrasena } from '../models/ICambioContrasena.interface'

import { IUsuarioDetallado } from '../models/usuario/IUsuarioDetallado.interface'
import { IHttpResponse } from 'src/app/core/models/IHttpResponse.interface'

@Injectable({ providedIn: 'root' })
export class UsuarioService {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = inject<string>('BASE_URL' as any)

  public ObtenerDetallado(cuentaId: number) {
    return this.http.get<IHttpResponse<IUsuarioDetallado[]>>(
      `${this.baseUrl}/api/v1/Sistema/Cuentas/${cuentaId}/Usuarios`,
    )
  }

  public cambiarContrasena(parametros: ICambioContrasena) {
    return this.http.patch(
      `${this.baseUrl}/api/v1/Sistema/Usuarios/${parametros.usuarioId}/CambioContrasena`,
      parametros,
    )
  }
}
